import { isVariantInStock } from '@lib/util/inventory';
import type { HttpTypes } from '@medusajs/types';

export type OptionsKeymap = Record<string, string>;

type VariantOptionLike =
  | Array<{ option_id?: string | null; value: string }>
  | null
  | undefined;

/**
 * The variant whose content/description should render before the user makes
 * an explicit selection — the first in-stock variant, falling back to the
 * first variant overall (e.g. when every variant is out of stock).
 */
export function getDefaultVariant(
  variants: HttpTypes.StoreProductVariant[] | null | undefined,
): HttpTypes.StoreProductVariant | undefined {
  const list = variants ?? [];
  if (list.length === 0) return undefined;
  return list.find((v) => isVariantInStock(v)) ?? list[0];
}

export function optionsAsKeymap(
  variantOptions: VariantOptionLike,
): OptionsKeymap | undefined {
  return variantOptions?.reduce<OptionsKeymap>((acc, varopt) => {
    if (varopt.option_id) {
      acc[varopt.option_id] = varopt.value;
    }
    return acc;
  }, {});
}

export function sameOptionsKeymap(
  a: Record<string, string | undefined> | undefined,
  b: Record<string, string | undefined> | undefined,
): boolean {
  if (!a || !b) return a === b;
  const keysA = Object.keys(a);
  return (
    keysA.length === Object.keys(b).length && keysA.every((k) => a[k] === b[k])
  );
}
